/**
 * API接口配置
 *
 */

import axios from 'axios';
import qs from 'qs';
import conf from './../../config/base.js';
import { setToken, getToken, clog ,getResouce} from "@/common/js/common";

/**
 * 获取自定义后的 ajax方法
 */
function getHttpIntegrate() {
  /**
   * http配置,调用集成接口
   */
  var instance = axios.create({
    baseURL: conf.api.api_owt,
    timeout: 60000,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded; charset=utf-8;"
      //"Content-Type": "application/json;charset=utf-8"
    }
  });
  var shaEncrypt = function(params){
    //要加密的字符字符串
    var encryptStr = 'token=' + params.token + '&appKey=' + params.appKey + '&timestamp=' + params.timestamp;
    encryptStr += '&v=' + params.v + '&resouce=' + params.resouce;
    //这里用的是require方法，所以没用import
    let sha256 = require("js-sha256").sha256;
    //console.log(encryptStr);
    return sha256(encryptStr);
  };
  var setHeaders  = function(config){
    var _params = {
      token : getToken(),
      appKey : "PYT_APPKEY",
      timestamp : new  Date().getTime(),
      v : "1.0",
      resouce : getResouce(),
      reqJson : JSON.stringify(config.data),
      sign:""
    };
    config.headers.common['sign'] = shaEncrypt(_params);
    config.headers.common['token'] = _params.token;
    config.headers.common['appKey'] = _params.appKey;
    config.headers.common['timestamp'] = _params.timestamp;
    config.headers.common['v'] = _params.v;
    config.headers.common['resouce'] = _params.resouce;
  };
  // http request 拦截器
  instance.interceptors.request.use(
    config => {
      //加密
      setHeaders(config);
      // POST传参序列化
      if (config.method === "post") {
        config.data = qs.stringify(config.data);
      }
      return config;
    },
    error => {
      //console.log("request error:" + error);
      return Promise.reject(error);
    }
  );

  // http response 拦截器
  instance.interceptors.response.use(
    response => { // 返回响应时做一些处理，我们这里直接返回
        return response;
    },
    error => {// 当响应异常时做一些处理\
      console.log("response error:" + error);
      return Promise.reject('网络异常 ,请稍后重试');
    }
  );
  return instance;
}

var api = {
  /**
   * 获取二维码
   */
  getToken(openid) {
    var __params = {"openid":openid};
    return getHttpIntegrate().post('/weixin/token', __params);
  },
  /**
   * 获取二维码
   */
  getJsapiSign(url) {
    var __params = {'url':url}
    return getHttpIntegrate().post('/weixin/jsapiticket', __params);
  },
  /**
   * pdf转图片
   */
  pdfToImg(pdfUrl) {
    var __params = {'pdfUrl':pdfUrl}
    return getHttpIntegrate().post('/xforce/pdftoimg', __params);
  },
  /**
   * 获取抬头列表
   */
  getInvoiceTitleList(page) {
    var __params = {'page':page,'size':12}
    return getHttpIntegrate().post('/invoice/title/unionid', __params);
  },
  /**
   * 获取抬头明细
   */
  getInvoiceTitleDetails(params) {
    return getHttpIntegrate().post("/invoice/title/id", params);
  },
  /**
   * 新增抬头
   */
  insertInvoiceTitle(params) {
    return getHttpIntegrate().post('/invoice/title/add', params);
  },
  /**
   * 新增抬头
   */
  delInvoiceTitle(id) {
    var __params = {'id':id};
    return getHttpIntegrate().post('/invoice/title/del', __params);
  },
  /**
   * 修改抬头
   */
  updateInvoiceTitle(params) {
    return getHttpIntegrate().post('/invoice/title/update', params);
  },
  /**
   * 获取订单信息
   */
  getOrderInfo(orderNo) {
    var __params = {"orderNo" : orderNo};
    return getHttpIntegrate().post("/order/query/id" , __params);
  },
  /**
   * 转换订单信息
   */
  decryptOrder(url) {
    var __params = {"url" : url};
    return getHttpIntegrate().post("/order/decrypt" , __params);
  },
  /**
   * 申请开票
   */
  applyEInvoice(__params){
    return getHttpIntegrate().post("/invoice/apply" , __params);
  },
  /**
   * 获取发票详情
   */
  getInvoiceDetail(__id,invoiceNo,invoiceCode) {
    var __params = {"id" : __id,'invoiceNo' : invoiceNo,'invoiceCode':invoiceCode};
    if(__id != null && __id !=''){
      return getHttpIntegrate().post("/invoice/query/id" , __params);
    }else{
      return getHttpIntegrate().post("/invoice/query/invoiceno" , __params);
    }
  },
  /**
   * 获取发票列表
   */
  getInvoiceList(page,size) {
    var __params = {"page":page,"size":size};
    return getHttpIntegrate().post("/invoice/query/list", __params);
  },
  /**
   *邮件发送
   */
  sendInvoiceEmail(invoiceId, email) {
    var __params = {'mainId':invoiceId,'mail':email};
    return getHttpIntegrate().post('/invoice/send/mail', __params);
  },
};

// 对 api 重新封装成一个plugin ,方便 Vue.use(xxxx)
//调用的时候 用 this.$webapi.deleteInvoiceTitle(....)
export default {
  install: function (Vue, Option) {
    Object.defineProperty(Vue.prototype, '$webapi', {
      value: api
    })
  }
}



// WEBPACK FOOTER //
// ./src/common/js/api.js